export default __webpack_public_path__ + "static/media/Zahl-7.8bf1b5dc.png";